import { Input, InputProps } from "@libertify/ui";
import styled from "styled-components";

/**
 * Input styled for the add-on config cards. Matches PlaybookSelect's 40px height
 * (the design system Input otherwise defaults to the theme's 32px controlHeight)
 * and renders at a fixed 140px width, per the design for these numeric fields.
 */
export const PlaybookInput = (props: InputProps) => {
  return <StyledInput {...props} />;
};

const StyledInput = styled(Input)`
  height: 40px !important;
  width: 140px;
`;
